module.exports = __webpack_public_path__ + "static/media/gallery-wrap4.a7eb5e4f.jpeg";